import Chip from '@mui/material/Chip';
import { GradientIcon } from 'src/components/gradients/GradientIcon';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Tooltip from '@mui/material/Tooltip';
import { useTheme } from '@mui/material';

export type InfoChipProps = {
  label: string;
  tooltipTitle: string;
  showAsWhitelisted: boolean;
};

type InfoTooltipProps = {
  title: string;
  showAsWhitelisted: boolean;
};

const InfoTooltip = ({ showAsWhitelisted }: InfoTooltipProps) => {
  return (
    <GradientIcon
      sx={{ width: 20, height: 20, ml: 1, mr: '-4px', mb: '-5px' }}
      IconComponent={InfoOutlinedIcon}
      gradientColor={
        showAsWhitelisted ? 'disabled.vertical' : 'royal.verticalInverse'
      }
    />
  );
};

export const InfoChip = ({ label, tooltipTitle, showAsWhitelisted }) => {
  const theme = useTheme();
  return (
    <Tooltip
      title={
        showAsWhitelisted ? (
          <>
            <span
              style={{ fontWeight: 700 }}
            >{`Whitelist access is required to rent this item.`}</span>{' '}
            {`${tooltipTitle}`}
          </>
        ) : (
          tooltipTitle
        )
      }
    >
      <Chip
        size="small"
        label={
          <span>
            {label}
            <InfoTooltip
              title={tooltipTitle}
              showAsWhitelisted={showAsWhitelisted}
            />
          </span>
        }
        variant={showAsWhitelisted ? 'disabledOutlined' : 'royalOutlined'}
        sx={{
          lineHeight: '20px',
          background: showAsWhitelisted
            ? theme.palette.action.disabled
            : undefined,
          boxShadow: showAsWhitelisted
            ? undefined
            : theme.shadowsHard['primaryElevation1'],
          fontWeight: 500,
          '&:hover': {
            cursor: 'pointer',
          },
          color: showAsWhitelisted
            ? theme.palette.text.secondary
            : theme.palette.text.primary,
        }}
      />
    </Tooltip>
  );
};
